<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item @click="goBack()">Detail Insurance</b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doSubmit" class="mt-2">
              <b-row>
                <b-col md="12">
                  <b-row>
                    <!-- <b-col md="5">
                      <label class="labels">brand *</label>
                      <div class="form-group" v-bind:class="errors.has('merk') ? 'has-error':''">
                        <b-form-input type="text" readonly class="form-control" v-bind:class="errors.has('merk') ? 'is-invalid':''" v-validate="'required'" data-vv-as="merk" name="merk" v-model="model.merk" placeholder="Enter Brand" />
                        <p v-if="errors.has('merk') !== null"></p>
                      </div>
                    </b-col>
                    <b-col md="2">
                    </b-col> -->
                    <b-col md="5">
                      <label class="labels">bill number *</label>
                      <div class="form-group" v-bind:class="errors.has('billNumber') ? 'has-error':''">
                        <b-form-input type="text" class="form-control" v-bind:class="errors.has('billNumber') ? 'is-invalid':''" v-validate="'required'" data-vv-as="billNumber" name="billNumber" v-model="model.billNumber" placeholder="Enter Bill Number" />
                        <p v-if="errors.has('billNumber') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <!-- <b-col md="5">
                      <label class="labels">model *</label>
                      <div class="form-group" v-bind:class="errors.has('model') ? 'has-error':''">
                        <b-form-input type="text" readonly class="form-control" v-bind:class="errors.has('model') ? 'is-invalid':''" v-validate="'required'" data-vv-as="model" name="model" v-model="model.model" placeholder="Enter Model" />
                        <p v-if="errors.has('model') !== null"></p>
                      </div>
                    </b-col>
                    <b-col md="2">
                    </b-col> -->
                    <b-col md="5">
                      <label class="labels">Insurance date * </label>
                      <div class="form-group" v-bind:class="errors.has('insuranceDate') ? 'has-error':''">
                        <b-form-datepicker type="date" class="form-control" v-bind:class="errors.has('insuranceDate') ? 'is-invalid':''" data-vv-as="insuranceDate" name="insuranceDate" v-model="insuranceDate" v-validate="'required'" placeholder="Enter Insurance Date" />
                        <p v-if="errors.has('insuranceDate') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <!-- <b-col md="5"> -->
                      <!-- <label class="labels">plate *</label>
                      <div class="form-group" v-bind:class="errors.has('plate') ? 'has-error':''">
                        <b-form-input type="text" readonly class="form-control" v-bind:class="errors.has('plate') ? 'is-invalid':''" v-validate="'required'" data-vv-as="plate" name="plate" v-model="model.plate" placeholder="Enter Plate" />
                        <p v-if="errors.has('plate') !== null"></p>
                      </div>
                    </b-col>
                    <b-col md="2">
                    </b-col> -->
                    <b-col md="5">
                      <label class="labels">amount *</label>
                      <div class="form-group" v-bind:class="errors.has('amount') ? 'has-error':''">
                        <b-form-input type="number" class="form-control" v-bind:class="errors.has('amount') ? 'is-invalid':''" v-validate="'required'" data-vv-as="amount" name="amount" v-model="model.amount" placeholder="Enter Amount" />
                        <p v-if="errors.has('amount') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">bill status *</label>
                      <div class="form-group" :required="true" v-bind:class="errors.has('status') ? 'has-error':''">
                        <b-form-select name="status" v-model="model.status" v-validate="'required'" v-bind:class="errors.has('status') ? 'is-invalid':''" :error="errors.first('status')" :options="statusList">
                        </b-form-select>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">bill Photo </label>
                      <b-form-file :required="false" label="Photo" v-model="model.photoBill1">
                      </b-form-file>
                      <!-- <b-form-file v-else :required="false" label="Photo" v-model="model.photoBill1">
                      </b-form-file> -->
                    </b-col>
                  </b-row>
                  <b-row>
                    <!-- <b-col md="7">
                    </b-col> -->
                    <b-col md="5 mt-3">
                      <label class="labels">note</label>
                      <div class="form-group" v-bind:class="errors.has('note') ? 'has-error':''">
                        <b-form-textarea rows="4" class="form-control" v-bind:class="errors.has('note') ? 'is-invalid':''" data-vv-as="note" name="note" v-model="model.note" placeholder="Enter Note" />
                        <p v-if="errors.has('note') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="mt-4">
                <b-button class="mr-2" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
                <b-button variant='warning' class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update </b-button>
              </div>
            </form>
        </b-card>
    </div>
</template>

<script>
  export default {
    name: 'insurance-form',
    data () {
      return {
        isLoading: false,
        apiUrl: {
          vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
        },
        model: {
          brand: null,
          model: null,
          plate: null,
          billNumber: null,
          type: null,
          photoBill1: null,
          amount: 0,
          options: [],
          status: "New",
          note: ""
        },
        statusList: [
          {
            value: 'New',
            text: 'Waiting For Payment'
          },
          {
            value: 'Paid',
            text: 'Paid'
          }
        ],
        insuranceDate: null
      }
    },
    mounted () {
      this.getDetail()
    },
    methods: {
      getDetail () {
          this.isLoading = true
          this.$http.get(this.apiUrl.vehicleBillInfo + '/' + this.$route.params.uuid).then(response => {
          this.model.billNumber = response.data.billNumber !== null ? response.data.billNumber : ''
          this.model.type = response.data.type !== null ? response.data.type : ''
          this.model.merk = response.data.vehicle !== null ? response.data.vehicle.merk : ''
          this.model.model = response.data.vehicle !== null ? response.data.vehicle.model : ''
          this.model.plate = response.data.vehicle !== null ? response.data.vehicle.plate : ''
          this.model.status = response.data.status !== null ? response.data.status : ''
          this.insuranceDate = response.data.dueDate !== null ? this.getDate(response.data.dueDate) : ''
          this.model.amount = response.data.amount !== null ? response.data.amount : ''
          this.model.note = response.data.note !== null ? response.data.note : ''
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      },
      doSubmit() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            let insuranceDate = {name: "insuranceDate", value: this.insuranceDate};
            this.model.options.push(insuranceDate)

            let formData = new FormData()
            formData.append('billNumber', this.model.billNumber)
            formData.append('amount', this.model.amount)
            formData.append('dueDate', this.insuranceDate)
            formData.append('status', this.model.status)
            formData.append('note', this.model.note)
            if (this.model.photoBill1 !== null) {
              formData.append('photoBill1', this.model.photoBill1, this.model.photoBill1.name)
            }
            if (this.model.uuid !== null) {
              let model = {}
              Object.keys(this.model).forEach(element => {
                if (element !== 'uuid') {
                  model[element] = this.model[element]
                }
              })
              this.$http.patch(this.apiUrl.vehicleBillInfo + '/' + this.$route.params.uuid, formData).then(response => {
                this.isLoading = false
                this.$store.dispatch('notification/success', 'Insurance data successfully updated.')
                this.goBack()
              }).catch(error => {
                this.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            }
          } else {
            swal("", "Please fill the required fields!", "info", {
              buttons: false,
              timer: 2000
            });
          }
        })
      },
      getDateTime (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD HH:mm A')
        } else {
          return '-'
        }
      },
      getDate (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD')
        } else {
          return '-'
        }
      },
      goBack () {
        window.goBack(this)
      },
      getStatusColor (val) {
        switch (parseInt(val)) {
        case 0:
          return 'success'
          break
        case 1:
          return 'info'
          break
        }
      },
    }
  }
</script>